import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Book14 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={14}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M12 1.75L3.5 1.75C3.08579 1.75 2.75 2.08579 2.75 2.5C2.75033 2.91394 3.08599 3.25 3.5 3.25L12.75 3.25V13C12.75 13.4142 12.4142 13.75 12 13.75H4C2.48122 13.75 1.25 12.5188 1.25 11V2.5C1.25 1.25736 2.25736 0.25 3.5 0.25H12V1.75ZM2.75 11V4.62197C2.98458 4.70488 3.23702 4.75 3.5 4.75L7.5 4.75V8L8.5 7L9.5 8V4.75H11.25V12.25H4C3.30964 12.25 2.75 11.6904 2.75 11Z'
      fill='currentColor'
    />
  </Svg>
);

Book14.displayName = 'Book14';
export default Book14;
